/* =========================================================
   Heatronics - keep the header cart count honest.

   THE BUG
   Everything that changes the cart from INSIDE the Shopflo
   drawer - the quantity stepper, the "+ ADD" upsells, remove -
   changes Shopify's cart server-side. The header bubble never
   hears about it, because the drawer is a cross-origin iframe
   and the theme only repaints the bubble on its own
   `cart:update`. So you add three things in the cart and the
   icon still says 1, until a full page load.

   WHAT MAKES IT EASY
   Shopflo already broadcasts the number. Captured live:
     {"type":"SET_CART_ITEM_COUNT","payload":{"totalItems":1},
      "source":"SHOPFLO"}
   That message is an instruction to the storefront to set the
   count, and nothing on this site was listening for it. The
   existing glue in the cart-icon snippet routes clicks and
   adds INTO the Shopflo cart; this is the missing return leg.

   WHY IT ALSO RE-READS THE CART
   The message is trusted but not relied on. Shopflo sends a
   `totalItems: 0` while the drawer is still booting, and a
   stale one landing after a real count would show the wrong
   number - which is what "doesn't update, always" looks like.
   So every message-driven paint is confirmed against
   /cart.js, which is the only source of truth, and the cart
   is re-read on the theme's own cart:update, on tab focus and
   on back/forward restores. A page served from Shopify's full
   page cache can also render a stale bubble, and the load-time
   sync catches that too.

   Deliberately written with NO regular expressions. The first
   version of this file used two, and the backslashes in them
   were doubled in transit through the theme API - which turned
   `/x/{2,}/g` into a syntax error and stopped the whole file
   from parsing. String methods cannot be mangled that way.

   Only the number is touched. No layout, no markup, no
   behaviour - if this file is removed the bubble simply goes
   back to being right only on a page load.
   ========================================================= */
(function () {
  if (window.__hbCartCountSync) return;
  window.__hbCartCountSync = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function url(path) {
    var root = ROOT;
    while (root.length && root.charAt(root.length - 1) === '/') root = root.slice(0, -1);
    while (path.charAt(0) === '/') path = path.slice(1);
    return root + '/' + path;
  }

  function fromShopflo(origin) {
    try {
      var h = new URL(origin).hostname;
      return h === 'shopflo.co' || h.slice(-11) === '.shopflo.co';
    } catch (e) {
      return false;
    }
  }

  /* Paint every cart bubble in the document - this theme renders
     one in the desktop header and one in the mobile header, and
     which is visible depends on the width. */
  function paint(count) {
    if (typeof count !== 'number' || count < 0 || count !== count) return;
    var bubbles = document.querySelectorAll('.cart-bubble');
    for (var i = 0; i < bubbles.length; i++) {
      var bubble = bubbles[i];
      var countEl = bubble.querySelector('.cart-bubble__text-count');
      var srEl = bubble.querySelector('.cart-bubble__text > .visually-hidden');
      if (countEl) {
        countEl.textContent = String(count);
        if (count === 0) countEl.classList.add('hidden');
        else countEl.classList.remove('hidden');
      }
      if (srEl) srEl.textContent = 'Total items in cart: ' + count;
      if (count === 0) bubble.classList.add('visually-hidden');
      else bubble.classList.remove('visually-hidden');
    }
  }

  var pending = null;

  function sync() {
    return fetch(url('cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        paint(cart.item_count);
      })
      .catch(function () { /* a failed read must never break the page */ });
  }

  function schedule(delay) {
    window.clearTimeout(pending);
    pending = window.setTimeout(sync, delay || 0);
  }

  /* 1. Shopflo speaking. Paint immediately so the number moves
        with the tap, then confirm against the server. */
  window.addEventListener('message', function (event) {
    if (!fromShopflo(event.origin)) return;
    var data = event.data;
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch (e) { return; }
    }
    if (!data || data.source !== 'SHOPFLO' || !data.type) return;

    if (data.type === 'SET_CART_ITEM_COUNT' && data.payload && typeof data.payload.totalItems === 'number') {
      paint(data.payload.totalItems);
      schedule(700);
      return;
    }
    if (data.type === 'CART_API_SUCCESS' ||
        data.type === 'REMOVE_CART_LOADING_STATE' ||
        data.type === 'CLOSE_CART_DATA') {
      schedule(250);
    }
  }, false);

  /* 2. The theme's own adds. It repaints the bubble itself, but
        it can render before the server has settled, so confirm. */
  document.addEventListener('cart:update', function () { schedule(400); });

  /* 3. Coming back to the tab, or via back/forward from a
        checkout that changed the cart. */
  window.addEventListener('pageshow', function () { schedule(0); });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) schedule(0);
  });

  /* 4. Load time, against a possibly cached bubble. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(0); });
  } else {
    schedule(0);
  }
})();